import React from 'react';
import { useTheme } from 'styled-components';

import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';
import { getContentByType } from '@glowforge/gf-styled/models/page';

import SocialCards from './social-cards-rebrand';

const SocialCardsWidget = ({ background, sections }) => {
  const { colors } = useTheme();

  const bg = background?.fields?.desktopColor?.fields;
  const backgroundColor = bg ? colors[bg.hue][bg.tint] : null;

  const carousel = sections?.find(
    ({ fields }) => fields.id === 'social-cards-homepage-rebrand'
  );

  const cards = carousel?.fields?.listItems;
  const title = carousel?.fields?.title;
  const icon = getContentByType(sections, 'icon')[0].fields?.svgAsset;

  return (
    <SocialCards
      backgroundColor={backgroundColor}
      cards={cards}
      title={title}
      icon={icon}
    />
  );
};

SocialCardsWidget.propTypes = widgetPropType;
SocialCardsWidget.defaultProps = widgetDefaultProps;

export default SocialCardsWidget;
